import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-new_summary_drop",
  "use": "icon-new_summary_drop-usage",
  "viewBox": "0 0 9.333 11.377",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9.333 11.377\" id=\"icon-new_summary_drop\"><defs><style>#icon-new_summary_drop .a{fill:#6da476;}</style></defs><g transform=\"translate(0 -0.001)\"><path class=\"a\" d=\"M4.667,11.377,9.333,5.354,6.27,6.039l-.049-.021-.038-.281A6.887,6.887,0,0,0,1.558,0,5.5,5.5,0,0,1,2.872,2.887,16.456,16.456,0,0,1,3.12,6.022H3.2l-.037.017L0,5.354Z\" transform=\"translate(0 0.001)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol